import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "./base.service";
import { AppSettings } from "../../app.settings";

@Injectable()
export class ESignService extends BaseService {

    constructor(private http: HttpClient,  private configuration: AppSettings) {
        super();
    }

    /** Gets the status of a e-sign document for all email recipients */
    getAllESignDocumentStatus(documentId: string): Observable<{ [key: string]: string }> {
        const url = `${this.configuration.BaseUrl}Profile/ESign/GetAllESignStatus?documentId=${documentId}`;
        return this.http.get<{ [key: string]: string }>(url, { headers: this.setHeaders() });
    }

    /** Gets the status of a e-sign document for a specific email */
    getESignDocumentStatus(documentId: string): Observable<string> {
        const url = `${this.configuration.BaseUrl}Profile/ESign/GetESignStatus?documentId=${documentId}`;
        return this.http.get<string>(url, { headers: this.setHeaders() });
    }

    /** Sends POST request to publish document for e-Sign and gets agreement ID */
    publishForESign(supplierCode: string, templateId: string, documentTypeId: number): Observable<{ agreementId: string }> {
        const url = `${this.configuration.BaseUrl}Profile/ESign/PublishDocumentForESign/${supplierCode}/${templateId}/${documentTypeId}`;
        return this.http.get<{ agreementId: string }>(url, { headers: this.setHeaders() });
    }

    /** Sends POST request to get the URL for signing the document of an agreement */
    getEsignUrl(agreementId: string): Observable<{ esignUrl: string, email: string }> {
        const url = `${this.configuration.BaseUrl}Profile/ESign/GetEsignUrl/${agreementId}`;
        return this.http.get<{ esignUrl: string, email: string }>(url, { headers: this.setHeaders() });
    }
}